import Link from 'next/link'
import React from 'react'

import InterviewPageContainer from '@/components/parts/interview/InterviewContainer'
import InterviewCustomerVoice from '@/components/parts/interview/InterviewCustomerVoice'
import InterviewMainImage from '@/components/parts/interview/InterviewMainImage'
import InterviewQA from '@/components/parts/interview/InterviewQA'
import { customerVoiceText, mainImageText, urbanGateQA } from '@/model/interview/urbanGateModel'
import { urlPath } from '@/utils/lpPath'

const UrbanGateInterview: React.FC = () => {
  return (
    <>
      <InterviewPageContainer
        company="アーバンゲート"
        interviewer="中村"
        ogUrl={`${process.env.NEXT_PUBLIC_PUBLIC_SITE_ORIGIN}${urlPath.urbanGate}`}
        baseImageUrl="/images/interview/urbanGate"
      >
        <InterviewMainImage {...mainImageText} textBottomPos="50%" />
        <InterviewCustomerVoice {...customerVoiceText}>
          {React.Children.toArray(
            urbanGateQA.map(({ question, answer }, index) => (
              <InterviewQA
                key={'urban' + index}
                number={index}
                question={question}
                answer={answer}
                imgUrl={`/images/interview/urbanGate/question${index + 1}.png`}
                isTextLeft={index % 2 == 1}
              />
            ))
          )}
          <div className="my-24 sp:mt-16">
            <Link href={urlPath.top} passHref>
              <a>
                <button className="return_button">戻る</button>
              </a>
            </Link>
            <a className="interviewTop" href={`#top`}>
              TOP
            </a>
          </div>
        </InterviewCustomerVoice>
      </InterviewPageContainer>
    </>
  )
}

export default UrbanGateInterview
